import ReactQuill from "react-quill";

const Quill = ReactQuill.Quill;

export const HELP_MANUAL_FONTS = [
  { label: "Inter", value: "inter" },
  { label: "Arial", value: "arial" },
  { label: "Georgia", value: "georgia" },
  { label: "Times New Roman", value: "times-new-roman" },
  { label: "Verdana", value: "verdana" },
  { label: "Courier New", value: "courier-new" },
];

export const HELP_MANUAL_FONT_SIZES = [
  { label: "10", value: "10px" },
  { label: "12", value: "12px" },
  { label: "14", value: "14px" },
  { label: "16", value: "16px" },
  { label: "18", value: "18px" },
  { label: "24", value: "24px" },
];

export const HELP_MANUAL_COLORS = [
  { label: "Black", value: "#111827" },
  { label: "Red", value: "#BE1C25" },
  { label: "Teal", value: "#3FAA88" },
  { label: "Blue", value: "#2563EB" },
  { label: "Orange", value: "#F97316" },
];

const Font = Quill.import("formats/font");
Font.whitelist = HELP_MANUAL_FONTS.map((font) => font.value);
Quill.register(Font, true);

const Size = Quill.import("attributors/style/size");
Size.whitelist = HELP_MANUAL_FONT_SIZES.map((size) => size.value);
Quill.register(Size, true);

export const helpManualQuillFormats = [
  "bold",
  "italic",
  "header",
  "list",
  "indent",
  "link",
  "image",
  "font",
  "size",
  "color",
];
